import { TrendingUp, TrendingDown, DollarSign, Handshake, Target, Briefcase } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { formatCurrency } from '@/lib/utils';

interface StatCardData {
  title: string;
  value: string;
  change: number;
  icon: React.ElementType;
}

export function StatsCards() {
  // Placeholder - will be wired to trpc.dashboard.overview
  const isLoading = false;

  const stats: StatCardData[] = [
    {
      title: 'Total Revenue',
      value: formatCurrency(0, 'CAD'),
      change: 0,
      icon: DollarSign,
    },
    {
      title: 'Deals Won',
      value: '0',
      change: 0,
      icon: Handshake,
    },
    {
      title: 'Avg Deal Size',
      value: formatCurrency(0, 'CAD'),
      change: 0,
      icon: Target,
    },
    {
      title: 'Pipeline Value',
      value: formatCurrency(0, 'CAD'),
      change: 0,
      icon: Briefcase,
    },
  ];

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {stats.map((stat) => (
        <Card key={stat.title}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              {stat.title}
            </CardTitle>
            <stat.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            {isLoading ? (
              <Skeleton className="h-8 w-24" />
            ) : (
              <>
                <div className="text-2xl font-bold">{stat.value}</div>
                <div className="flex items-center gap-1 mt-1">
                  {stat.change >= 0 ? (
                    <TrendingUp className="h-3 w-3 text-emerald-500" />
                  ) : (
                    <TrendingDown className="h-3 w-3 text-red-500" />
                  )}
                  <span
                    className={`text-xs ${
                      stat.change >= 0 ? 'text-emerald-500' : 'text-red-500'
                    }`}
                  >
                    {stat.change >= 0 ? '+' : ''}
                    {stat.change}% from last period
                  </span>
                </div>
              </>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
